// ==========================================================
// AXIOS INSTANCE FOR API CALLS
// ==========================================================
// This instance is used across the frontend to communicate
// with the Flask backend.
//
// IMPORTANT:
// - baseURL must match Flask server
// - withCredentials must be TRUE for session authentication
// ==========================================================

import axios from "axios";

const api = axios.create({

  // ✅ Backend API base URL
  // Must match Flask server exactly
  //baseURL: "http://localhost:5000/api",
  baseURL: "/api",

  // ✅ Required for Flask session authentication
  // Sends session cookie with every request
  withCredentials: true,
});


// ==========================================================
// ⭐ NEW: RESPONSE INTERCEPTOR
// ==========================================================
// This safely handles authentication errors without breaking UI.
// It DOES NOT redirect automatically (so existing behavior remains).
// It only logs useful debugging info.
// ==========================================================

api.interceptors.response.use(

  // Successful response
  (response) => {
    return response;
  },

  // Error response
  (error) => {

    // ⭐ ADDED: Handle unauthorized access safely
    if (error.response && error.response.status === 401) {

      console.warn("⚠️ User not authenticated (401)");

      // We do NOT redirect here to avoid breaking existing navigation
      // The React app can handle this if needed
    }

    // Log all API errors for debugging
    console.error("API Error:", error);

    return Promise.reject(error);
  }

);


// ==========================================================
// EXPORT AXIOS INSTANCE
// ==========================================================

export default api;
